export enum SPECIAL_INVOICE {
    DEFAULT = 'FE',
}

export type SpecialInvoiceType = SPECIAL_INVOICE.DEFAULT;
